'use client';

import { atom } from 'jotai';

import type { FlagKey } from '@growthBookExperimentation/Entities/FlagKeys.entities';

export const pageviewExperimentAtom = atom(null as null | FlagKey[]);
